// Global constants for SEO Meta fields
export const META_TITLE_MAX_LENGTH = 60;
export const META_DESCRIPTION_MAX_LENGTH = 250;

// Recommended minimum lengths
export const META_TITLE_MIN_LENGTH = 50;
export const META_DESCRIPTION_MIN_LENGTH = 120;
